import { _ } from '../utils'
import { throttle } from '../utils/throttle'

class MatchHeight {
    constructor(el) {
        self = this
        this.matcher = el
        this.twinName = this.matcher.getAttribute('data-height-twin')
        this.twin = _(this.twinName, 'element').node()

        if (this.twin != null) {
            this.setMinHeight()
            window.addEventListener('resize', throttle(self.setMinHeight, 500))
        }
    }

    setMinHeight = () => {
        this.matcher.style['min-height'] = this.twin.offsetHeight + 'px'
    }
}

export default MatchHeight